module.exports = __webpack_public_path__ + "img/no-recent-analyses.47fbe9a.png";